import { render } from "./dailyRetailSummary.vue?vue&type=template&id=348b5e8a&scoped=true"
import script from "./dailyRetailSummary.vue?vue&type=script&lang=js"
export * from "./dailyRetailSummary.vue?vue&type=script&lang=js"

import "@/assets/custom-outside.css?vue&type=style&index=0&id=348b5e8a&scoped=true&lang=css"

import exportComponent from "/Users/ittiwutwongsawat/Documents/GitHub/clinic/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-348b5e8a"]])

export default __exports__